export function formatEconomicHorizon(years) {
  const value = Number(years);
  if (!Number.isInteger(value) || value < 1) return "Unavailable";
  return `${value} ${value === 1 ? "year" : "years"}`;
}

export default function EconomicBasisDisclosure({ economicHorizonYears }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700" aria-label="Economic Basis">
      <p className="font-semibold text-slate-800">Economic Basis</p>
      <p className="mt-1">
        Economic Horizon: <strong>{formatEconomicHorizon(economicHorizonYears)}</strong>
        {" · "}Investment Basis: Upfront modeled capital
        {" · "}Valuation Basis: Undiscounted
      </p>
    </div>
  );
}
